// extracted by mini-css-extract-plugin
export var layoutContainer = "_bp-0";
export var layoutContainerNoRounding = "_bp-6";
export var layoutContainerOpen = "_bp-5";
export var layoutContainerResizing = "_bp-1";
export var mainContent = "_bp-2";
export var resizeDivider = "_bp-3";
export var slidePanel = "_bp-4";